import React from 'react';
import styles from './FilterMenuSection.module.scss';
import { Checkbox, Menu } from 'antd';
import cn from 'classnames';

const FilterMenuSection = ({
  label = '',
  onMenuClick,
  fieldValue,
  selectedKeys,
  options,
  selectedValuesFilter,
}) => {
  return (
    <div className={styles.boxItem}>
      <div className={styles.text}>{label}</div>
      <div style={{ marginLeft: 10 }}>
        <Menu
          onClick={({ key }) => onMenuClick(key, fieldValue)}
          multiple
          selectedKeys={selectedKeys}
          className={styles.menu}
        >
          {options?.map((item) => {
            const valueFilter = Object.values(selectedValuesFilter).find(
              (value) => value.id === item.id
            );

            return (
              <Menu.Item
                className={cn({
                  [styles.selected]: selectedKeys?.includes(String(item.id)),
                })}
                key={item.id}
                disabled={!valueFilter}
              >
                <Checkbox
                  className={styles.checkbox}
                  value={item.id}
                  checked={selectedKeys?.includes(String(item.id))}
                />
                <div className={styles.content}>
                  <div>{item.name}</div>
                  <div>{valueFilter ? valueFilter.count : 0}</div>
                </div>
              </Menu.Item>
            );
          })}
        </Menu>
      </div>
    </div>
  );
};

export default FilterMenuSection;
